import { format } from "date-fns"

export const parseTimestamp = (timestamp: string | Date): { date: string; time: string } => {
    const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
    
    return {
        date: format(date, 'dd.MM.yyyy'),
        time: format(date, 'HH:mm:ss')
    }
}

